<div class="container">
    <div class="sidenav">
        <nav class="sidebar" id="sidebar">
            <ul>
                <li>
                    <button mat-button [routerLink]="['/']" routerLinkActive="active" (click)="toggleSidebar()"
                        [routerLinkActiveOptions]="{exact: true}" class="sidebar-image-button">
                        <mat-icon>home</mat-icon>
                        <span class="sidebar-text">HOME</span>
                    </button>
                </li>
                <h5> IN EVIDENZA </h5>
                <li>
                    <button mat-button [routerLink]="['/welcome']" routerLinkActive="active" (click)="toggleSidebar()"
                        [routerLinkActiveOptions]="{exact: true}" class="sidebar-image-button">
                        <mat-icon>emoji_people</mat-icon>
                        <span class="sidebar-text">Welcome</span>
                    </button>
                </li>
                <li>
                    <button mat-button [routerLink]="['/associazione']" routerLinkActive="active"
                        (click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
                        class="sidebar-image-button">
                        <mat-icon>groups</mat-icon>
                        <span class="sidebar-text">Associazione</span>
                    </button>
                </li>
                <li>
                    <button mat-button [routerLink]="['/attivita']" routerLinkActive="active" (click)="toggleSidebar()"
                        [routerLinkActiveOptions]="{exact: true}" class="sidebar-image-button">
                        <mat-icon>public</mat-icon>
                        <span class="sidebar-text">Attività</span>
                    </button>
                </li>
                <li>
                    <button mat-button [routerLink]="['/ixh25']" routerLinkActive="active"
                        (click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
                        class="sidebar-image-button">
                        <mat-icon>auto_stories</mat-icon>
                        <span class="sidebar-text">IXH25</span>
                    </button>
                </li>
		   <li>
                    <button mat-button [routerLink]="['/pqcifris25']" routerLinkActive="active"
                        (click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
                        class="sidebar-image-button">
                        <mat-icon>dashboard</mat-icon>
                        <span class="sidebar-text">PQCifris25</span>
                    </button>
                </li>
                <h5> INFORMAZIONI </h5>
                <li>
                    <button mat-button [routerLink]="['/contatti']" routerLinkActive="active" (click)="toggleSidebar()"
                        [routerLinkActiveOptions]="{exact: true}" class="sidebar-image-button">
                        <mat-icon>mail</mat-icon>
                        <span class="sidebar-text">Contatti</span>
                    </button>
                </li>
                <li>
                    <button mat-button [routerLink]="['/sitemap']" routerLinkActive="active" (click)="toggleSidebar()"
                        [routerLinkActiveOptions]="{exact: true}" class="sidebar-image-button">
                        <mat-icon>pin_drop</mat-icon>
                        <span class="sidebar-text">Sitemap</span>
                    </button>
                </li>
                <li>
                    <button mat-button [routerLink]="['/cookie-policy']" routerLinkActive="active"
                        (click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
                        class="sidebar-image-button">
                        <mat-icon>cookie</mat-icon>
                        <span class="sidebar-text">Cookies</span>
                    </button>
                </li>
            </ul>
        </nav>
    </div>
    <div class="content" (click)="toggleSidebar(true)">
        <router-outlet></router-outlet>
    </div>
    <ul class="bottomnav-menu">
        <li>
            <button mat-button [routerLink]="['/']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                <mat-icon style="color:var(--cifris_azure_transparent);">home</mat-icon>
                <span style="color:var(--cifris_azure_transparent);">HOME</span>
            </button>
        </li>
        <li>
            <button mat-button [routerLink]="['/welcome']" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <mat-icon>emoji_people</mat-icon>
                <span>Welcome!</span>
            </button>
        </li>
        <li>
            <button mat-button [routerLink]="['/associazione']" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <mat-icon>groups</mat-icon>
                <span>Associazione</span>
            </button>
        </li>
        <li>
            <button mat-button [routerLink]="['/attivita']" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <mat-icon>public</mat-icon>
                <span>Attività</span>
            </button>
        </li>
        <li>
            <button mat-button [routerLink]="['/ixh25']" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <mat-icon>auto_stories</mat-icon>
                <span>IXH25</span>
            </button>
        </li>
        <li>
            <button mat-button [routerLink]="['/contatti']" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <mat-icon>mail</mat-icon>
                <span>Contatti</span>
            </button>
        </li>
        <li>
            <button mat-button [routerLink]="['/sitemap']" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <mat-icon>pin_drop</mat-icon>
                <span>Sitemap</span>
            </button>
        </li>
        <li>
            <button mat-button [routerLink]="['/cookie-policy']" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <mat-icon>cookie</mat-icon>
                <span>Cookies</span>
            </button>
        </li>
    </ul>
</div>
